<template>
  <div class="pcDetail pc" @click.self="hide" ref="detail" @scroll="handleScroll" v-empty="empty"
    :empty-text="emptyText">
    <div class="d-container" ref="container" v-if="data">
      <div class="img">
        <img :src="data.url" @click.self="showPreviewImg(true)" />
        <!-- <img src="~@/assets/images/demo/1@2x.png" @click.self="showPreviewImg(true)" /> -->
      </div>
      <div class="d-right">
        <div class="toolbar d-toolbar">
          <div class="download d-download" @click="downImg()"></div>
          <div :class="{collect: true, hasCollect: data.collectStatus === 1, 'd-collect': true, button: true}"
            @click="doCollectSingle">
            <div class="icon"></div>
            <div class="text">
              {{ data.collectStatus === 1 ? $t('934ebd87e6') : data.collectNum == 0 ? $t('ae336cd047') : data.collectNum }}
            </div>
          </div>
        </div>
        <div class="toolbar d-hide">
          <div class="download d-download" @click="downImg()"></div>
          <div :class="{collect: true, hasCollect: data.collectStatus === 1, 'd-collect': true, button: true}"
            @click="doCollectSingle">
            <div class="icon"></div>
            <div class="text">
              {{ data.collectStatus === 1 ? $t('934ebd87e6') : data.collectNum == 0 ? $t('ae336cd047') : data.collectNum }}
            </div>
          </div>
        </div>
        <div class="text-view">
          <div class="title">{{ data.title }}</div>
          <div class="text-info">
            <span class="time">{{ data.imgDate }}</span>
          </div>
          <div class="tags-container">
            <span v-for="item in data.tagNameList" :key="item.id" class="tags">
              {{ item }}
            </span>
          </div>
        </div>
        <div class="text">{{ data.content }}</div>
        <div class="zhan"></div>
        <div class="beizhu">{{ $t('1c6e68c78d') }}</div>
      </div>
    </div>
    <div class="d-recommend" v-if="relatedData.length > 0">
      <div class="title">
        <div class="line" :style="{width: `${containerWidth}px`}">
          <span class="text">{{ $t('35f414b9c2') }}</span>
        </div>
      </div>
      <div class="container" id="imgList">
        <imgList key="detail" :data="relatedData" :collect="false" :loadDistance="300" :type="4" :detail="true"
          :slideId="slideId" v-if="show" />
      </div>
    </div>
    <div class="b-left" @click="increase" v-if="!empty"></div>
    <div class="b-right" @click="add" v-if="!empty"></div>
    <div class="b-close" @click="hide" v-if="!empty"></div>
    <preview v-show="showPreview" ref="preview" />
    <div class="backTop" @click="backTop" v-if="showBackTop"></div>
  </div>
</template>
<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
import { getDetail, getRelated, collect, download } from '@/api/apiList';
import imgList from '@/components/pc/imgList';
import preview from '@/components/pc/preview';
import { mapState } from 'vuex';
import { uniqueArr, throttle, getCookie } from '@/common';
export default {
  data() {
    return {
      data: 1,
      hasCollect: 0,
      empty: '',
      emptyText: $t('21efd88b67'),
      relatedData: [],
      detailFinish: false,
      detailId: '',
      // 列表宽度
      containerWidth: 1920,
      show: false,
      last: null,
      next: null,
      type: 1,
      content: '',
      load: false,
      oldId: null,
      showPreview: false,
      showBackTop: false,
      group: '',
      changeSlideId: true,
      handleScroll: () => {},
    };
  },
  provide() {
    return {
      group: () => this.group,
    };
  },
  // props: {
  //   id: {
  //     type: Number,
  //     default: 1,
  //   },
  //   type: {
  //     type: Number,
  //     default: 1,
  //   },
  // },
  computed: {
    collectFixed() {
      return this.$ref.containerWidth;
    },
  },
  components: {
    imgList,
    preview,
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      document.title = $t('6ab5f11fbd');
      vm.id = to.query.id;
      vm.type = to.query.type;
      vm.content = to.query.content;
      vm.group = to.query.group;
      vm.changeSlideId = to.query.change;
      vm.slideId = to.query.slideId + '';
      vm.renderView();
    });
  },
  // beforeRouteUpdate(to, from, next) {
  //   next(vm => {
  //     document.title = '图说数据';
  //     vm.id = to.query.id;
  //     vm.type = to.query.type;
  //     vm.renderView();
  //   });
  // },
  beforeRouteLeave(to, from, next) {
    this.show = false;
    this.relatedData = [];
    next();
  },
  methods: {
    scroll(e) {
      if (this.load) {
        return;
      }
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      console.log(scrollHeight - scrollTop - clientHeight);
      if (scrollHeight - scrollTop - clientHeight < 200) {
        this.getRelatedData();
      }
    },
    scroll2(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      this.showBackTop = scrollTop > 100;
      if (this.load) {
        return;
      }
      let container = document.querySelector('.d-container');
      let toolbar = document.querySelector('.d-toolbar');
      let hide = document.querySelector('.d-hide');
      if (container && toolbar && hide) {
        if (scrollTop > container?.clientHeight + 24 - 74) {
          toolbar.style.top = 0;
        } else {
          let top = scrollTop - 24;
          if (top < 0) {
            top = 0;
          }
          toolbar.style.top = `${top}px`;
        }
      }
    },
    backTop() {
      this.$refs.detail.scrollTop = 0;
    },
    renderView() {
      this.load = true;
      this.data = null;
      this.last = null;
      this.next = null;
      this.showBackTop = false;
      let toolbar = document.querySelector('.d-toolbar');
      if (toolbar) {
        toolbar.style.top = 0;
      }
      this.$refs.container && this.$refs.container.scrollIntoView();
      this.detailId = '';
      this.detailFinish = false;
      this.relatedData = [];
      this.show = false;
      this.getData();
      this.getRelatedData();
    },
    add() {
      if (this.next === null) {
        return;
      }
      this.data = null;
      this.id = this.next;
      this.slideId = this.next + '';
      this.$refs.detail.scrollIntoView();
      this.renderView();
    },
    increase() {
      if (this.last === null) {
        return;
      }
      this.data = null;
      this.id = this.last;
      this.slideId = this.last + '';
      this.$refs.detail.scrollIntoView();
      this.renderView();
    },
    hide() {
      this.$parent.id = 1;
      this.data = null;
      if (this.type == 1) {
        this.$router.push('/dataImage');
      } else {
        this.$router.push('/dataCollect');
      }
    },
    showPreviewImg(val) {
      if (window.viewer) {
        window.viewer.destroy();
      }
      let _this = this;
      let rage = (window.innerHeight - 128) / window.innerHeight;
      const viewer = new Viewer(document.querySelector('.d-container'), {
        className: 'img_viewer',
        title: false,
        button: false,
        navbar: false,
        toolbar: false,
        initialCoverage: parseFloat(rage).toFixed(2),
        url(image) {
          if (image) {
            let url = location.protocol + image.getAttribute('src');
            console.log(url);
            return url;
          } else {
            return '';
          }
        },
        hide() {
          _this.showPreview = false;
        },
        viewed() {
          _this.$refs.preview.zoom = parseFloat(
            window.viewer.imageData.ratio
          ).toFixed(2);
          _this.$refs.preview.oldzoom = parseFloat(
            window.viewer.imageData.ratio
          ).toFixed(2);
          let img = document.querySelector('.viewer-canvas img');
          img.style.marginTop = '32px';
        },
        // move(e) {
        //   const { x, y } = e.detail;
        //   let w = window.innerWidth;
        //   let h = window.innerHeight;
        //   if (x < 0 || y < 0 || x > w || y > h) {
        //     viewer.reset();
        //   }
        // },
        zoomed(e) {
          _this.$Bus.$emit('zoom', e.detail.ratio);
          // viewer.image.style.marginTop = '33px';
        },
      });
      window.viewer = viewer;
      viewer.show();
      this.showPreview = val;
    },
    async doCollect(id) {
      let i = this.relatedData.findIndex(d => d.id == id);
      console.log(i);
      let collectStatus = Number(!this.relatedData[i].collectStatus);
      let res = await collect({
        id: +this.relatedData[i].id,
        action: collectStatus,
      });
      if (res && res.code === 1) {
        this.relatedData[i].collectStatus = collectStatus;
        this.$store.commit('setCollect', {
          id: this.id,
          action: Number(!this.hasCollect),
        });
        if (this.relatedData[i].collectStatus) {
          this.$message.success($t('f62827f0c4'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.shoucang',
          });
          setTimeout(() => {
            this.$Talog({
              id: 'iFinD_appStore_tssj_pc_favour',
              img_id: this.data[i].id,
            });
          }, 500);
        } else {
          this.data.collectNum =
            this.data.collectNum - 1 < 0 ? 0 : this.data.collectNum - 1;
          this.$message.success($t('cb0f88686e'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.quxiaoshoucang',
          });
        }
      } else {
        if (res === 401) {
          this.$message.error($t('66ef92bbe5'));
          return;
        } else {
          this.$message.error($t('b32b0111c1'));
        }
      }
    },
    async doCollectSingle() {
      let collectStatus = Number(!this.data.collectStatus);
      let res = await collect({
        id: +this.data.id,
        action: collectStatus,
      });
      if (res && res.code === 1) {
        this.data.collectStatus = collectStatus;
        if (this.type == 2) {
          this.$store.commit('setMyCollect', {
            id: +this.data.id,
            action: collectStatus,
          });
        } else {
          this.$store.commit('setCollect', {
            id: +this.data.id,
            action: collectStatus,
          });
        }
        if (this.data.collectStatus) {
          this.$message.success($t('f62827f0c4'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.shoucang',
          });
          setTimeout(() => {
            this.$Talog({
              id: 'iFinD_appStore_tssj_pc_favour',
              img_id: this.id,
            });
          }, 500);
        } else {
          this.data.collectNum =
            this.data.collectNum - 1 < 0 ? 0 : this.data.collectNum - 1;
          this.$message.success($t('cb0f88686e'));
          this.$Talog({
            id: 'iFinD_news_tssj_tupian.quxiaoshoucang',
          });
        }
      } else {
        if (res === 401) {
          this.$message.error($t('66ef92bbe5'));
          return;
        } else {
          this.$message.error($t('0b6d2219c6'));
        }
      }
    },
    async downImg() {
      this.$Talog({
        id: 'iFinD_news_tssj_tupian.xiazai',
      });
      setTimeout(() => {
        this.$Talog({
          id: 'iFinD_appStore_tssj_pc_download',
          sid: Date.now(),
          img_id: this.data.id,
        });
      }, 500);
      this.$Talog({
          id: 'iFinD_appStore_tssj_pc_download_' + window.source,
          platform: window.source,
          sid: Date.now(),
          img_id: this.data.id,
      });
      if (getCookie('jgbsessid')) {
        let url = location.protocol + this.data.url;
        let href = `ifind://!command=down&filename=${this.data.title}.jpg&valuectrl=1&url=${url}`;
        location.href = href;
      } else {
        let img = new Image();
        let item = this.data
        img.setAttribute('crossOrigin', 'Anonymous');
        img.onload = function () {
          let canvas = document.createElement('canvas');
          let context = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          context.drawImage(img, 0, 0, img.width, img.height);
          canvas.toBlob(blob => {
            let thumbnailUrl = item.thumbnailUrl.split('.');
            const type = thumbnailUrl[thumbnailUrl.length - 1];
            const link = document.createElement('a')
            link.download = `${item.title}.${type}`;
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
          });
        };
        img.src = item.thumbnailUrl + '?v=' + Date.now();
      }
    },
    async getData() {
      let params = {
        id: this.id,
        type: this.type,
        content: this.content,
        slideId: this.slideId,
      };
      if (this.group !== '') {
        params.type = 3;
        params.tagType = this.group;
      }
      if(params.tagType == 0){
        params.type = 1
      }
      let res = await getDetail(params).catch(error => {
        this.empty = 'error';
        this.emptyText = $t('866b795eae');
      });
      if (res && res.code === 1) {
        let { data } = res;
        if (!data.id) {
          if (!this.oldId) {
            this.empty = 'data';
            return;
          }
          this.id = this.oldId;
          this.data = null;
          this.$refs.detail.scrollIntoView();
          this.renderView();
        } else {
          this.last = data.last;
          this.next = data.next;
          this.data = data;
          this.oldId = data.id;
        }
      } else {
        this.data = null;
      }
    },
    async getRelatedData() {
      if (!this.detailFinish) {
        let res = await getRelated({
          id: this.id,
          page: 13,
          needCollect: 1,
          relatedId: this.detailId,
        }).catch(error => {
          this.empty = 'error';
          this.emptyText = $t('866b795eae');
        });
        this.show = true;
        if (res && res.code === 1) {
          let { data } = res;
          this.load = false;
          if (data) {
            if (data.length == 0) {
              this.detailFinish = true;
              return;
            }
            this.relatedData = uniqueArr(this.relatedData.concat(data));
            //更新滚动所需要的参数
            this.detailId = data[data.length - 1].id;
            this.empty = '';
          } else {
            this.relatedData = [];
          }
        } else {
          this.load = false;
          this.error = true;
        }
      }
    },
  },
  created() {
    this.handleScroll = throttle(this.scroll, 600);
    document.body.style.minWidth = '1366px';
  },
  mounted() {
    this.$Bus.$on('updateLineWidth', width => {
      this.containerWidth = width;
    });
    // 获取指定元素
    const scrollview = this.$refs['detail'];
    // 添加滚动监听，该滚动监听了拖拽滚动条
    // 尾部的 true 最好加上，我这边测试没加 true ，拖拽滚动条无法监听到滚动，加上则可以监听到拖拽滚动条滚动回调
    scrollview.addEventListener('scroll', this.scroll2, true);
  },
  // beforeDestroy 与 destroyed 里面移除都行
  beforeDestroy() {
    // 获取指定元素
    const scrollview = this.$refs['detail'];
    // 移除监听
    scrollview.removeEventListener('scroll', this.scroll2, true);
  },
};
</script>
<style lang="less" scoped>
.pcDetail {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  position: absolute;
  background: rgba(245, 247, 249, 0.98);
  margin: 0 auto;
  top: 0;
  left: 0;
  margin: 0 auto;
  padding-top: 24px;
  cursor: url(~@/assets/images/increase.svg), pointer;
  .d-container {
    width: 948px;
    background: #ffffff;
    box-shadow: 0px 0px 32px 0px rgba(71, 71, 98, 0.1);
    border-radius: 20px;
    position: relative;
    margin: 0 auto;
    margin-bottom: 24px;
    display: flex;
    .img {
      width: 50%;
      // height: 100%;
      min-width: 474px;
      border-radius: 20px 0 0 20px;
      cursor: url(~@/assets/images/expend.svg), pointer;
      display: flex;
      flex-shrink: 0;
      align-items: center;
      img {
        display: inline-flex;
        border-radius: 20px;
        width: 100%;
      }
    }
  }
  .d-recommend {
    background: #fff;
    margin-top: 24px;
    cursor: auto;
    .line {
      background-image: linear-gradient(
        to right,
        #ececf7 0%,
        #ececf7 80%,
        transparent 50%
      );
      margin: 0 auto;
      background-size: 15px 1px;
      background-repeat: repeat-x;
      position: relative;
      background-position: center;
      /* top: 10px; */
      height: 56px;
      line-height: 56px;
      display: flex;
      justify-content: center;
      .text {
        font-family: MicrosoftYaHei-Bold;
        font-size: 18px;
        color: #474762;
        letter-spacing: 0;
        text-align: center;
        font-weight: 700;
        background: #fff;
      }
    }
  }
  .d-right {
    width: 50%;
    padding: 0 24px;
    cursor: auto;
    position: relative;
    top: 0;
    right: 0;
    display: inline-block;
    .toolbar {
      width: 100%;
      height: 80px;
      justify-content: space-between;
      align-items: center;
      display: flex;
      position: relative;
      background: #ffffff;
      z-index: 9;
      .download {
        width: 32px;
        height: 32px;
        background: url(~@/assets/images/c_down.svg) no-repeat 16px 16px;
        background-position: center;
        z-index: 999;
        cursor: pointer;
        background-color: rgba(255, 255, 255, 0.9);
        border: 1px solid #cbcbe1;
        border-radius: 8px;
        &:hover {
          width: 32px;
          height: 32px;
          border: 1px solid #1b63d9;
          border-radius: 8px;
        }
      }
      .collect {
        padding: 0 10px;
        height: 32px;
        background: #1b63d9;
        border-radius: 8px;
        right: 0;
        z-index: 998;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
          background: url(~@/assets/images/star.svg) no-repeat 100% 100%;
        }
        .text {
          font-size: 14px;
          color: #ffffff;
          line-height: 32px;
        }
        &:hover {
          background: #3c79de;
        }
        &:hover .star {
          background: url(~@/assets/images/star-hover.svg) no-repeat 100% 100%;
        }
      }
      .hasCollect {
        background: #4a4b72;
        &:hover {
          background: #757699;
        }
      }
    }
    .d-hide {
      top: 48px;
      display: none;
    }
    .text-view {
      width: 100%;
      border-bottom: 1px solid #ececf7;
      .title {
        font-family: MicrosoftYaHei-Bold;
        font-size: 20px;
        color: #272841;
        letter-spacing: 0;
        text-align: justify;
        font-weight: 700;
      }
      .text-info {
        margin: 8px 0 12px 0;
        .time {
          font-family: ArialMT;
          font-size: 14px;
          color: #7d7d94;
          letter-spacing: 0;
          text-align: center;
          font-weight: 400;
          padding-right: 8px;
        }
      }
      .tags-container {
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        display: flex;
        width: 100%;
        flex-wrap: wrap;
        margin: 0 0 8px 0;
        margin-right: 8px;
        justify-content: flex-start;
      }
    }
    .text {
      font-family: Microsoft YaHei;
      font-size: 14px;
      color: #474762;
      letter-spacing: 0;
      text-align: justify;
      line-height: 22px;
      font-weight: 400;
      padding: 12px 0;
    }
    .zhan {
      width: 100%;
      height: 64px;
    }
    .beizhu {
      border-top: 1px solid #ececf7;
      font-family: Microsoft YaHei;
      font-size: 12px;
      color: #7d7d94;
      letter-spacing: 0;
      text-align: justify;
      line-height: 20px;
      font-weight: 400;
      padding: 12px 12px 0 12px;
      position: absolute;
      bottom: 12px;
      left: 12px;
      width: calc(100% - 24px);
    }
  }
  .b-left {
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/left.svg) no-repeat 100% 100%;
    position: fixed;
    left: 32px;
    top: 50vh;
    cursor: pointer;
    z-index: 999;
    &:hover {
      background: url(~@/assets/images/left_hover.svg) no-repeat 100% 100%;
    }
  }
  .b-right {
    width: 48px;
    height: 48px;
    background: url(~@/assets/images/next.svg) no-repeat 100% 100%;
    position: fixed;
    right: 32px;
    top: 50vh;
    cursor: pointer;
    z-index: 999;
    &:hover {
      background: url(~@/assets/images/next_hover.svg) no-repeat 100% 100%;
    }
  }
  .b-close {
    width: 24px;
    height: 24px;
    background: url(~@/assets/images/p_close.svg) no-repeat 100% 100%;
    background-size: 24px 24px;
    position: fixed;
    right: 46px;
    top: 32px;
    cursor: pointer;
    z-index: 999;
    &:hover {
      background: url(~@/assets/images/p_close_hover.svg) no-repeat 100% 100%;
      background-size: 24px 24px;
    }
  }
}
.tags {
  background: rgba(27, 99, 217, 0.1);
  border-radius: 2px;
  font-family: Microsoft YaHei;
  font-size: 14px;
  color: #1b63d9;
  text-align: center;
  line-height: 20px;
  font-weight: 400;
  padding: 1px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  &:nth-child(1) {
    margin-left: 0;
  }
}
.backTop {
  width: 48px;
  height: 48px;
  background: url(~@/assets/images/backTop.svg) no-repeat 100% 100%;
  position: fixed;
  right: 32px;
  bottom: 32px;
  cursor: pointer;
  z-index: 999;
  &:hover {
    background: url(~@/assets/images/backTop_hover.svg) no-repeat 100% 100%;
  }
}
</style>
